import { Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import profile from 'assets/dummy/profile.svg';
import {
  CategoryScale,
  Chart,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import dayjs from 'dayjs';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { fontsize15, poppins600 } from 'theme/common.style';
import { dateformatBasedOnUserType } from 'api/apiService';
import {
  Processingbatch,
  Winnerbatch,
} from 'component/BuyersMarketplace/Marketplaceicons';
import { datacontext } from 'modules/AppLayout/AppLayout';
Chart.register(annotationPlugin);
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
function LineChart({
  sector,
  offers,
  activity,
  vendor,
  insbydate,
  list,
  getListInfo,
  potraitMode,
  tableData,
  timerStatus,
  isStageTwo,
  isWinner,
  viewAllOffer,
  primaryUserTypeValue,
}) {
  let datalabel = ['Week0'];
  let datalabelins = [];
  let offerdatalabel = [];
  let isConditional = [];
  let offeredtime = [];
  let offerPrice = [];
  let buyername = [];
  let vendorStatus = [];
  let stage2;
  let winneramount;
  let InspectedCount = [0];
  let SimilarInspectedAvgCount = [0];

  const [InspectedCountval, setInspectedCountval] = useState(true);
  const [SimilarInspectedAvgCountval, setSimilarInspectedAvgCountval] =
    useState(true);
  const [buyerId, setBuyerId] = useState('');
  const [manageOffer, setManageOffer] = useState(false);
  const [offerUniqueId, setOfferUniqueId] = useState(false);
  const [vendorStatusval, setVendorStatusval] = useState(false);
  const [hoverfunc, sethoverfunc] = useState(false);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  const { realTimeLog } = useContext(datacontext);

  useEffect(() => {
    if (!realTimeLog) return;

    if (typeof getListInfo === 'function') {
      getListInfo();
    }
  }, [realTimeLog]);

  const labelClick = (e, elements) => {
    try {
      if (elements.length != 0 && vendor != true) {
        setBuyerId(sector[elements[0].index].buyerId);
        setOfferUniqueId(sector[elements[0].index].offerUniqueId);
        setVendorStatusval(sector[elements[0].index].vendorStatusval);
        setManageOffer(true);
      }
      if (elements.length != 0 && vendor) {
        setBuyerId(sector[elements[0].index].buyerId);
        setOfferUniqueId(sector[elements[0].index].offerUniqueId);
        setVendorStatusval(sector[elements[0].index].vendorStatusval);

        setManageOffer(true);
      }
    } catch (error) {
      console.log(error, 'errror');
    }
  };

  if (offers == true) {
    sector?.rightColumn?.forEach((item) => {
      InspectedCount.push(item.offersCount);
    });
    sector?.rightColumn?.forEach((item) => {
      SimilarInspectedAvgCount.push(item.similarOffersAvgCount);
    });
    sector?.rightColumn?.forEach((item) => {
      datalabel.push('Week' + item.week);
    });
  } else if (activity == true) {
    if (sector) {
      if (sector?.length > 0) {
        sector?.map((item, index) => {
          offerdatalabel.push('Offer' + (index + 1));
        });
        const dataLabel = offerdatalabel.length + 1;
        const dataLabel1 = offerdatalabel.length + 2;
        offerdatalabel.push('Offer' + dataLabel);
        offerdatalabel.push('Offer' + dataLabel1);
        offerdatalabel.push('');

        sector?.map((item, index) => {
          isConditional.push(
            item?.isConditional == '1' ? 'Conditional' : 'Unconditional'
          );
        });
        isConditional.push('');

        sector?.map((item, index) => {
          offeredtime.push(
            dateformatBasedOnUserType(item?.createdAt, primaryUserTypeValue)
          );
        });
        offeredtime.push('');

        sector?.forEach((item) => {
          offerPrice.push(parseInt(item.offerPrice.replace(/\$|,/g, ''), 10));
          // offerPrice.push(item?.offerPrice);
          // offerPrice.push(1000,100000,1500,5000,111250000,222224940);
        });
        sector?.forEach((item) => {
          if (vendor) {
            buyername.push(
              item?.buyerName +
                ' ' +
                (item?.buyerSurName).charAt(0).toUpperCase()
            );
          } else {
            buyername.push(item?.buyerName + ' ' + item?.buyerSurName);
          }
        });
        sector?.forEach((item, index) => {
          if (item?.vendorStatus == 'Accepted') {
            vendorStatus.push('Offer' + (index + 1));
          }
          if (item?.isWinner == 1) {
            let data = {
              value: 'Offer' + (index + 1),
              color: 'rgba(11, 168, 218, 1)',
            };
            vendorStatus.push(data);
          }
        });
        sector?.forEach((item, index) => {
          if (item?.isStageTwoTurning == 1) {
            // stage2.push("Offer" + (index+1));
            stage2 = index;
            winneramount = item?.offerPrice;
          }
        });
      } else {
        offerdatalabel = ['Offer1'];
        // sector?.forEach((item) => {
        //   offerPrice.push(item?.offerPrice);
        // });
      }
    }
  } else if (insbydate == true) {
    sector?.rightColumn?.userInspectionByDate?.forEach((item) => {
      InspectedCount.push(item.value);
    });
    sector?.rightColumn?.similarUserInspectionByDate?.forEach((item) => {
      SimilarInspectedAvgCount.push(item.value);
    });
    sector?.rightColumn?.userInspectionByDate?.forEach((item) => {
      let dateval = dayjs(item.key).format('DD-MMM');
      datalabelins.push(dateval);
      datalabel = datalabelins;
    });
  } else {
    sector?.rightColumn?.forEach((item) => {
      InspectedCount.push(item.inspectedCount);
    });
    sector?.rightColumn?.forEach((item) => {
      SimilarInspectedAvgCount.push(item.similarInspectedAvgCount);
    });
    sector?.rightColumn?.forEach((item) => {
      datalabel.push('Week' + item.week);
    });
  }
  useEffect(() => {
    list?.length > 0 &&
      list?.map((item) => {
        if (item?.dataset == 'Inspected Count') {
          if (item?.visible == true) {
            setInspectedCountval(true);
          } else {
            setInspectedCountval(false);
          }
        }
        if (item?.dataset == 'Similar Inspected Avg Count') {
          if (item?.visible == true) {
            setSimilarInspectedAvgCountval(true);
          } else {
            setSimilarInspectedAvgCountval(false);
          }
        }
      });
  }, [list]);

  const [badgePosition, setBadgePosition] = useState(null);
  const processingBadgePlugin = {
    id: 'processingBadgePlugin',
    afterDatasetsDraw(chart, args, pluginOptions) {
      const dataset = chart?.data?.datasets?.[0];
      const meta = chart?.getDatasetMeta?.(0);
      const isSpecial = pluginOptions?.isSpecial;
      const sector = pluginOptions?.sector;
      const highestStageTwoItem = pluginOptions?.highestStageTwoItem;

      if (
        !dataset ||
        !meta?.data ||
        !isSpecial ||
        !sector ||
        !highestStageTwoItem
      )
        return;

      const processingIndex = sector?.findIndex(
        (item) =>
          item?.isStageTwo == 1 &&
          parseInt(item?.offerPrice?.replace(/\$|,/g, ''), 10) ==
            parseInt(highestStageTwoItem?.offerPrice?.replace(/\$|,/g, ''), 10)
      );

      const point = meta.data[processingIndex];
      if (!point) return;

      const badgeX = point.x - 65;
      const badgeY = point.y - 70;

      if (typeof chart.config.options.setBadgePos === 'function') {
        chart.config.options.setBadgePos({ left: badgeX, top: badgeY });
      }
    },
  };

  const winnerBadgePlugin = {
    id: 'winnerBadgePlugin',
    afterDatasetsDraw(chart, args, pluginOptions) {
      const dataset = chart?.data?.datasets?.[0];
      const meta = chart?.getDatasetMeta?.(0);
      const winnerIndex = pluginOptions?.winnerIndex;

      if (!dataset || !meta?.data || winnerIndex == undefined) return;

      const point = meta.data[winnerIndex];
      if (!point) return;

      const badgeX = point.x - 65;
      const badgeY = point.y - 80;

      if (typeof chart.config.options.setBadgePos == 'function') {
        chart.config.options.setBadgePos({ left: badgeX, top: badgeY });
      }
    },
  };

  const createBlurredProfileImage = (profileSrc, size = 50) => {
    return new Promise((resolve) => {
      const glowSize = 30;
      const canvasSize = size + glowSize * 2;

      const canvas = document.createElement('canvas');
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const ctx = canvas.getContext('2d');

      const center = canvasSize / 2;

      const img = new Image();
      // img.crossOrigin = 'anonymous';
      img.src = profileSrc;

      img.onload = () => {
        ctx.save();
        ctx.filter = 'blur(10px)';
        ctx.fillStyle = '#6C2AD280';
        ctx.beginPath();
        ctx.arc(center, center, size / 2 + 9, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        const imgOffset = center - size / 2;
        ctx.save();
        ctx.beginPath();
        ctx.arc(center, center, size / 2, 0, Math.PI * 2);
        ctx.clip();
        ctx.drawImage(img, imgOffset, imgOffset, size, size);
        ctx.restore();

        resolve(canvas);
      };

      img.onerror = (err) => {
        resolve(null);
      };
    });
  };

  const createCircularImage = (src, size = 30) => {
    return new Promise((resolve) => {
      if (!src) return resolve(null);

      const img = new Image();
      img.src = src;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');

        ctx.beginPath();
        ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, 0, 0, size, size);

        resolve(canvas);
      };

      img.onerror = () => {
        resolve(null);
      };
    });
  };

  const createInitialsImage = (name, surname, size = 50) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.fillStyle = '#666666';
      ctx.fill();

      const initials = `${(name?.[0] || '').toUpperCase()}${(
        surname?.[0] || ''
      ).toUpperCase()}`;
      ctx.fillStyle = '#FFFFFF';
      ctx.font = `${size / 2 - 2}px Poppins, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(initials, size / 2, size / 2);

      resolve(canvas);
    });
  };

  const [pointImages, setPointImages] = useState([]);
  const [suggestedMax, setSuggestedMax] = useState(null);

  const labelLength = winneramount?.length || 0;

  const dynamicPadding = labelLength >= 10 ? 10 : labelLength >= 8 ? 10 : 12;
  const userType = JSON.parse(localStorage.getItem('userType'))?.userType;

  useEffect(() => {
    if (!activity) return;

    const getHighestStageTwoOffer = () => {
      const stageTwoItems = (sector || [])?.filter(
        (item) => item?.isStageTwo == 1
      );
      if (!stageTwoItems?.length) return null;

      const maxPrice = Math.max(
        ...stageTwoItems.map((item) =>
          parseInt(item?.offerPrice?.replace(/\$|,/g, ''), 10)
        )
      );

      const highestItems = stageTwoItems
        .filter(
          (item) =>
            parseInt(item?.offerPrice?.replace(/\$|,/g, ''), 10) == maxPrice
        )
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      return highestItems[0];
    };

    const loadSmallImages = () =>
      Promise.all(
        (sector || [])?.map((item) => {
          if (userType == 'Vendor' || !item?.profileImage) {
            return createInitialsImage(item?.buyerName, item?.buyerSurName, 30);
          }
          return createCircularImage(item?.profileImage, 30);
        })
      );

    const run = async () => {
      const smallImages = await loadSmallImages();
      const imgLarge = await Promise.all(
        (sector || [])?.map((item) => {
          if (userType == 'Vendor' || !item?.profileImage) {
            return createInitialsImage(item?.buyerName, item?.buyerSurName, 50);
          }
          return createBlurredProfileImage(item?.profileImage);
        })
      );

      if (!smallImages || !imgLarge) {
        setPointImages(smallImages?.length ? smallImages : []);
        setSuggestedMax(null);
        return;
      }

      const highestStageTwoOffer = getHighestStageTwoOffer();

      const imagesArray = (sector || [])?.map((item, index) => {
        if (item?.isWinner == 1) return imgLarge[index];

        const isProcessingSpecial =
          item?.isStageTwo == 1 &&
          isWinner == 0 &&
          isStageTwo == 'ST2' &&
          timerStatus == 'End' &&
          item?.offerUniqueId == highestStageTwoOffer?.offerUniqueId;

        if (isProcessingSpecial) return imgLarge[index];

        return smallImages[index];
      });

      setPointImages(imagesArray);

      if ((sector || [])?.some((item) => item?.isWinner == 1)) {
        const winnerPrices = (sector || [])
          ?.filter((item) => item?.isWinner == 1)
          ?.map((item) => parseInt(item?.offerPrice?.replace(/\$|,/g, ''), 10));

        const sortedWinnerPrices = [...winnerPrices].sort((a, b) => a - b);
        const highest = sortedWinnerPrices[sortedWinnerPrices?.length - 1];
        let gap =
          sortedWinnerPrices?.length >= 2
            ? highest - sortedWinnerPrices[sortedWinnerPrices?.length - 2]
            : highest * 0.1;
        if (gap == 0) {
          gap = highest * 0.05;
        }

        setSuggestedMax(highest + 4 * gap);
      } else {
        const highestStageTwoItem = highestStageTwoOffer;

        const isProcessingSpecialGlobal =
          highestStageTwoItem &&
          isWinner == 0 &&
          isStageTwo == 'ST2' &&
          timerStatus == 'End';

        if (isProcessingSpecialGlobal) {
          const offerPrices = (sector || [])?.map((item) =>
            parseInt(item?.offerPrice?.replace(/\$|,/g, ''), 10)
          );
          const sorted = [...offerPrices].sort((a, b) => a - b);
          const highest = sorted[sorted?.length - 1] || 0;
          let gap =
            sorted?.length >= 2
              ? highest - sorted[sorted?.length - 2]
              : highest * 0.1;
          if (gap == 0) {
            gap = highest * 0.1;
          }

          setSuggestedMax(highest + 2 * gap);
        } else {
          setSuggestedMax(null);
        }
      }
    };

    run();
  }, [profile, sector, isStageTwo, timerStatus, isWinner, activity]);

  const highestStageTwoItem = Array.isArray(sector)
    ? sector
        ?.filter((item) => item?.isStageTwo == 1)
        ?.reduce(
          (maxItem, current) => {
            const currentPrice = parseInt(
              current?.offerPrice?.replace(/\$|,/g, ''),
              10
            );
            const maxPrice = parseInt(
              maxItem?.offerPrice?.replace(/\$|,/g, ''),
              10
            );
            return currentPrice > maxPrice ? current : maxItem;
          },
          { offerPrice: '$0' }
        )
    : { offerPrice: '$0' };

  useEffect(() => {
    if (ref?.current) {
      ref.current.update();
    }
  }, [sector, highestStageTwoItem]);

  const isProcessingSpecial =
    isWinner == 0 &&
    isStageTwo == 'ST2' &&
    timerStatus == 'End' &&
    highestStageTwoItem?.offerPrice;

  const data = {
    labels: !activity ? datalabel : offerdatalabel,
    datasets: [
      InspectedCountval && {
        label: !activity
          ? offers
            ? 'Offers Count'
            : insbydate
            ? 'User Inspection By Date'
            : 'Inspected Count'
          : 'Offer price',
        data: !activity ? InspectedCount : offerPrice,
        borderColor: '#0077b6',
        backgroundColor: '#0077b6',
        borderWidth: 2,
        tension: activity ? 0.3 : 0,
        pointRadius: activity ? 10 : 2,
        pointStyle: activity ? (ctx) => pointImages[ctx.dataIndex] : null,
        labels: buyername,
      },

      !activity &&
        SimilarInspectedAvgCountval && {
          label: offers
            ? 'Similar Offers Avg Count'
            : insbydate
            ? 'Similar User Inspection By Date'
            : 'Similar Inspected Avg Count',
          data: SimilarInspectedAvgCount,
          borderColor: 'rgb(153, 102, 255)',
          backgroundColor: 'rgb(153, 102, 255)',
          borderWidth: 2,
        },
    ].filter(Boolean), // 🔥 THIS LINE FIXES IT
  };
  var annotation = vendorStatus.map((value, index) => {
    return {
      type: 'line',
      id: 'vline' + index,
      mode: 'vertical',
      scaleID: 'x',
      value: value?.value ? value?.value : value,
      borderDash: [10, 5],
      borderColor: value?.color ? value?.color : 'green',
      borderWidth: 1,
    };
  });

  let annotation1 = {
    drawTime: 'afterDraw',
    type: 'box',
    id: 'vline',
    mode: 'vertical',
    xMin: stage2 + 0.15,
    xMax: stage2 + 0.15,
    borderDash: [5, 10],
    borderColor: 'red',
    borderWidth: 1,
    label: {
      display: true,
      content: winneramount,
      position: isProcessingSpecial ? 'end' : 'topright',
      yAdjust: 0,
      font: { size: 10, weight: 'bold' },
      padding: {
        top: 4,
        bottom: 4,
        left: dynamicPadding,
        right: dynamicPadding,
      },
      borderColor: 'blue',
      borderWidth: 1,
      borderDash: [0],
      backgroundColor: 'rgba(0, 85, 255, 0.64)',
    },
  };
  if (stage2 >= 0) {
    annotation.push(annotation1);
  }
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        right: stage2 >= (sector?.length || 0) - 2 ? 80 : 0,
      },
    },
    elements: {
      point: {
        radius: isProcessingSpecial ? 20 : 15,
        hitRadius: isProcessingSpecial ? 25 : 20,
        hoverRadius: isProcessingSpecial ? 25 : 18,
      },
    },
    onClick: (e, elements) => labelClick(e, elements),
    interaction: {
      mode: 'nearest',
      intersect: false,
    },
    plugins: {
      legend: {
        display: !activity,
      },

      tooltip: activity && {
        enabled: false,
        external: function (context) {
          const chart = context.chart;
          let tooltipEl = document.getElementById('chartjs-tooltip');

          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';

            Object.assign(tooltipEl.style, {
              position: 'absolute',
              pointerEvents: 'none',
              background: '#F8F8F8',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '8px',
              fontSize: '13px',
              lineHeight: '1.3',
              whiteSpace: 'nowrap',
              transition: 'opacity 0.1s ease',
              transformOrigin: 'top left',
            });

            chart.canvas.parentNode.appendChild(tooltipEl);
          }

          const tooltipModel = context.tooltip;

          if (!tooltipModel || tooltipModel.opacity == 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          let html = '';

          tooltipModel.dataPoints.forEach((dp) => {
            const index = dp.dataIndex;

            const bg =
              isConditional[index] == 'Conditional'
                ? 'rgba(237,11,11,0.6)'
                : 'rgb(16,211,94)';

            html += `
      <div style="display:flex;flex-direction:column;gap:4px">
        <div style="display:flex;justify-content:space-between;gap:8px">
          <strong>${offerdatalabel[index]}</strong>
          <span style="
            background:${bg};
            color:#fff;
            padding:2px 6px;
            border-radius:3px;
            font-size:11px;
          ">
            ${isConditional[index]}
          </span>
        </div>
        <div>
          ${buyername[index]} Offered Price:
          $${offerPrice[index].toLocaleString('en-US')}
        </div>
        <div>${offeredtime[index]}</div>
      </div>
    `;
          });

          tooltipEl.innerHTML = html;

          const { caretX, caretY } = tooltipModel;
          const canvasRect = chart.canvas.getBoundingClientRect();

          const anchorX = caretX;
          const anchorY = caretY;
          const rawWidth = tooltipEl.offsetWidth;
          const rawHeight = tooltipEl.offsetHeight;

          const POINT_RADIUS =
            tooltipModel.dataPoints?.[0]?.element?.options?.radius || 10;

          const GAP = 6;

          let left = caretX - rawWidth / 2;
          let top = caretY - rawHeight - POINT_RADIUS - GAP;

          // ✅ Prevent left overflow
          if (left < 8) {
            left = 8;
          }

          // ✅ Prevent right overflow (important for last point)
          const containerWidth = chart.width;
          if (left + rawWidth > containerWidth - 8) {
            left = containerWidth - rawWidth - 8;
          }

          // ✅ Flip below if no space above
          if (top < 8) {
            top = caretY + POINT_RADIUS + GAP;
          }

          tooltipEl.style.left = `${left}px`;
          tooltipEl.style.top = `${top}px`;
          tooltipEl.style.opacity = 1;
        },
      },
      annotation: activity && {
        annotations: annotation,
        // {
        //   vendorStatus.map((value, index)=> {

        //     return {

        //     type: 'line',
        //     id: 'vline' + index,
        //     mode: 'vertical',
        //     scaleID: 'x',
        //     value:value,
        //     borderDash: [10,5],
        //     borderColor: 'green',
        //     borderWidth: 1,

        //   };
        // })
        // annotation1

        // line1:{
        //   type: 'box',
        //       id: 'vline' ,
        //       mode: 'vertical',
        //       xMin: stage2 + 0.5,
        //       xMax: stage2 + 0.5,
        //       borderDash: [5,10],
        //       borderColor: 'red',
        //       borderWidth: 1,
        //       backgroundColor:"transparent"
        // },
        // annotation
        //     vendorStatus.map((value, index)=> {

        //     return {
        //    ("line"+index) : {
        //     type: 'line',
        //     id: 'vline' + index,
        //     mode: 'vertical',
        //     scaleID: 'x',
        //     value:value,
        //     borderDash: [10,5],
        //     borderColor: 'green',
        //     borderWidth: 1,
        //    }
        //   };
        // })
        // }
      },
    },

    onHover: (event, chartElement) => {
      if (chartElement && chartElement.length > 0) {
        sethoverfunc(true);
      } else {
        sethoverfunc(false);
      }
    },
    scales: {
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        beginAtZero: true,
        suggestedMax: Math.max(...offerPrice) * 1.2,
        // suggestedMin: Math.min(...offerPrice) / 1.5,
        // min: Math.min(...offerPrice) / 1.5,
        suggestedMin: 0,
        grace: '15%',
        ticks: {
          padding: 20,
          callback: function (value) {
            if (value >= 1_000_000_000)
              return (
                (value / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
              );
            if (value >= 1_000_000)
              return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
            if (value >= 1_000)
              return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
            return value;
          },
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        grace: '5%',
        // offset: true,
        ...(activity &&
          // sector?.length == 1 &&
          sector[0]?.isWinner == 1 && {
            offset: true,
            grace: '1%',
          }),
      },
    },
  };
  useEffect(() => {
    if (document.getElementById('chartjs-tooltip-style')) return;

    const style = document.createElement('style');
    style.id = 'chartjs-tooltip-style';
    style.innerHTML = `
    #chartjs-tooltip {
      opacity: 0;
      position: absolute;
      background: #F8F8F8;
      border: 1px solid #ccc;
      border-radius: 3px;
      pointer-events: none;
      transition: all 0.1s ease;
      padding: 10px;
    }
  `;
    document.head.appendChild(style);
  }, []);

  let [downloadLineChart, setDownloadLineChart] = useState('');

  let ref = useRef(null);

  const DownloadImg = useCallback(() => {
    let link = document.createElement('a');
    link.download = 'LineChart.png';
    link.href = ref.current.toBase64Image();
    setDownloadLineChart(link);
    // link.click();
  });

  useEffect(() => {
    DownloadImg();
  }, [setDownloadLineChart]);

  return (
    <Grid
      style={{
        display: 'flex',
        paddingTop: '5px',
        height: '100%',
        width: potraitMode ? '1300px' : '100%',
        overflowX: 'auto',
      }}
    >
      <Card
        style={{
          borderRadius: '8px',
          padding: '15px',
          // margin: "10px",
          height: '100%',
          boxShadow: 'none',
          minWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#ffff',
          gap: '20px',
        }}
      >
        {!activity && (
          <Grid item display={'flex'} justifyContent={'left'}>
            <Typography
              sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
            >
              {' '}
              {offers ? 'Number of offers' : 'Campaign Buyers graph'}
            </Typography>
          </Grid>
        )}
        <Grid
          item
          sx={{
            flex: 1,
            minHeight: 0,
            height: '100%',
          }}
        >
          <div
            style={{
              position: 'relative',
              height: '250px',
            }}
          >
            <Line
              ref={ref}
              data={data}
              options={{
                ...options,
                ...(activity && { setBadgePos: setBadgePosition }),
                plugins: {
                  ...options.plugins,
                  ...(activity && {
                    processingBadgePlugin: {
                      isSpecial: isProcessingSpecial,
                      sector: sector,
                      highestStageTwoItem: highestStageTwoItem,
                    },
                    winnerBadgePlugin: {
                      winnerIndex: sector?.findIndex(
                        (item) => item?.isWinner == 1
                      ),
                    },
                  }),
                },
              }}
              plugins={
                activity ? [processingBadgePlugin, winnerBadgePlugin] : []
              }
              style={{ cursor: hoverfunc ? 'pointer' : 'default' }}
            />
            {badgePosition && (
              <div
                style={{
                  position: 'absolute',
                  left: badgePosition.left,
                  top: badgePosition.top,
                  pointerEvents: 'none',
                }}
              >
                {isWinner == 1 ? (
                  <Winnerbatch />
                ) : userType != 'Vendor' ? (
                  <Processingbatch />
                ) : null}
              </div>
            )}
          </div>
        </Grid>
      </Card>
      {offerUniqueId && (
        <ManageOffer
          lineChart={true}
          offerUniqueId={offerUniqueId}
          buyerId={buyerId}
          open={manageOffer}
          manageOffer={manageOffer}
          setManageOffer={setManageOffer}
          getListInfo={getListInfo}
          vendorStatus={vendorStatusval}
          // openBox={openBox}
          // setOpenBox={setOpenBox}
          moxouserId={true}
          tableData={tableData}
        />
      )}
    </Grid>
  );
}

export default LineChart;
